module.exports = __webpack_public_path__ + "img/v3-forward-light.70c9c7a5.svg";